import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';

type Req = { userQuizId?: string };

type Response = void;

type Return = {
  isError: boolean;
  isUpdating: boolean;
  updateQuizConnectionTime: (req: Req) => Promise<Response>;
};

export const useUpdateQuizConnectionTime = (): Return => {
  const { t } = useTranslationWithPrefix('utils.errors');
  const { user } = useUserContext();
  const { restUserQuizApi } = useApiClient();
  const { isError, isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      if (!user?.userId || !req.userQuizId) {
        toast.error(t('unexpectedError'));
        throw new Error('Unexpected error - userId or userQuizIdis not defined');
      }
      if (isPending || isError) {
        return;
      }
      await restUserQuizApi.updateQuizConnectionTime(user.userId, req.userQuizId, {
        timeout: 3000,
      });
    },
    mutationKey: ['useUpdateQuizConnectionTime'],
  });

  return {
    isError,
    isUpdating: isPending,
    updateQuizConnectionTime: mutateAsync,
  };
};
